import { useState } from "react";
import { FaImage } from "react-icons/fa";
import { Link } from "react-router-dom";

const CaseStudiesCard = ({ image, title, text  }) => {
  const [hover, setHover] = useState(false);

  return (
    <div className="overflow-hidden max-w-[350px] bg-gray-100 hover:cursor-pointer">
      <Link to={`/case-study/${title.toLowerCase()}`}>
        <div
          className="relative w-full h-auto overflow-hidden"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <img
            src={image}
            alt={title}
            className={`w-full  object-cover transition-all duration-300 ${
              hover ? "brightness-50" : "brightness-100"
            }`}
          />
          {hover && (
            <div className="absolute inset-0 flex items-center justify-center text-3xl text-white ">
              <FaImage className="border-[#fff] border-[1px] rounded-[50%] p-1" />
            </div>
          )}
        </div>
        <div className="pt-2">
          <h3 className="text-lg ">{title}</h3>
          <p className="mt-1 text-xs text-gray-600 leading-normal">{text}</p>
        </div>
      </Link>
    </div>
  );
};

export default CaseStudiesCard;
